import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { useContext } from '../../Context'
import { useConfirmDialog } from '@ztechapps/common.hook'

export const ResetFilterMenuItem = () => {
  const { onReset } = useContext()

  const { onConfirm } = useConfirmDialog({
    title: 'Reset Filters & Sorting?',
    text: 'This will reset search, filters, sorting, and return to page 1.',
    buttons: {
      confirm: {
        text: 'Yes, reset it!',
      },
    },
    confirmed: onReset,
  })

  return (
    <Dropdown.Item title="Reset search, filters, sorting, and return to page 1." onClick={onConfirm}>
      <div>Reset filters...</div>
    </Dropdown.Item>
  )
}
